import React from "react";
import { Modal, Box, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    tableCell: {
        padding: '0 !important',
    },
    box: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        maxHeight: "80vh",
        backgroundColor: "#FFF",
        borderRadius: 2,
        boxShadow: 24,
        padding: 12,
        display: "flex",
        flexDirection: "column",
        borderRadius: 12
    },
}));

export default function ModalEstoqueOutrasLojas({ estoqueOutrasLojas, modalEstoqueOutrasLojasOpen, setModalEstoqueOutrasLojasOpen }) {
    const classes = useStyles();

    return (
        <Modal
            open={modalEstoqueOutrasLojasOpen}
            onClose={() => setModalEstoqueOutrasLojasOpen(false)}
        >
            <Box className={classes.box}>

                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6">{estoqueOutrasLojas[0]?.prodNomeSemAcento}</Typography>
                    <IconButton onClick={() => setModalEstoqueOutrasLojasOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                
                <Box>
                </Box>
                {/* Tabela */}
                <Box sx={{ overflowY: "scroll" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                                <TableCell className={classes.tableCell}><b>Nome da loja</b></TableCell>
                                <TableCell className={classes.tableCell}><b>Estoque</b></TableCell>
                            </TableRow>
                        </TableHead>
                        {estoqueOutrasLojas && estoqueOutrasLojas.length > 0 && <TableBody>
                            {estoqueOutrasLojas.map((item, index) => {
                                return <TableRow key={index}>
                                    <TableCell className={classes.tableCell}>{item.nomeFilial}</TableCell>
                                    <TableCell className={classes.tableCell}>{item.estoque}</TableCell>
                                </TableRow>
                            })}
                        </TableBody>
                        }
                    </Table>
                </Box>

            </Box>
        </Modal>
    );
}